import React, { FC } from 'react';
import SeatsPreview from '@/components/SeatsPreview/SeatsPreview';

interface TableRowProps {
  players: number;
  maxPlayers: number;
  variant: string;
  name: string;
  onClick?: (() => void) | (() => Promise<void>) | undefined;
}
const TableRowName: FC<TableRowProps> = ({ players, maxPlayers, variant, name, onClick }) => {
  return (
    <div className="flex items-center gap-5" onClick={onClick}>
      <SeatsPreview occupiedSeats={players} maxPlayers={maxPlayers} />
      <div className="w-full overflow-hidden">
        <span className="truncate whitespace-nowrap font-bold text-ph-gray-white">{name}</span>
        <p className="text-white text-opacity-50">{variant}</p>
      </div>
    </div>
  );
};

export default TableRowName;
